exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.checkbox-skinny[data-v-3e6e44c8]{ margin: 70% 0px 0px 40%\n}\n.checkbox-border[data-v-3e6e44c8]{ border: 1px solid #cccccc; border-radius: 4px; height: 34px;\n}\n.space-left[data-v-3e6e44c8]{ padding-left: 2px !important;}\n.space-right[data-v-3e6e44c8]{ padding-right: 2px !important;}\n", ""]);

// exports
